export const functions = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    name: { en: 'Name', ko: '이름', fr: '' },
    uri: { en: 'URI', ko: 'URI', fr: '' },
    description: { en: 'Description', ko: '비고', fr: '' },
  },
  info: {
    name: { en: 'Name', ko: '이름', fr: '' },
    uri: { en: 'URI', ko: 'URI', fr: '' },
    description: { en: 'Description', ko: '비고', fr: '' },
  },
};
